// extracted by mini-css-extract-plugin
export default {"myOrders":"MyOrders_myOrders__alra3","tabla":"MyOrders_tabla__LXUpY","notFound":"MyOrders_notFound__Bmu6x"};